import { forwardRef } from "react";
import { Flex, SystemProps, Text } from "@storyofams/react-ui";

import { FileUnion, FlowNodeType } from "~/graphql/api/sdk";

import { OptionChoice } from "../OptionChoice";
import { OptionImage } from "../OptionImage";

import { Option } from "./Option";

interface OptionItem {
  id: string;
  label: string;
  description?: string;
  image?: FileUnion;
  emoji?: string;
}

export interface OptionsProps {
  fieldType: FlowNodeType;
  loading: boolean;
  name: string;
  onChange(value: string[]): void;
  options: OptionItem[];
  optionProps?: SystemProps;
  type: "checkbox" | "radio";
  value: string[];
  maxSelections?: number;
  alignment?: "left" | "center" | "right";
  pageSettings?: any;
}

export const Options = forwardRef(
  (
    { fieldType, name, options, loading, optionProps, onChange, type, value, maxSelections, alignment, pageSettings, ...props }: OptionsProps & SystemProps,
    forwardedRef: any
  ) => {
    const isMultipleChoice = fieldType === FlowNodeType.ImageMulti || fieldType === FlowNodeType.EmojiMulti || fieldType === FlowNodeType.SimpleMulti;

    const areChoicesDisabled = (isMultipleChoice && !!maxSelections && value.length >= maxSelections) as boolean;

    return (
      <Flex
        justifyContent={alignment === "center" ? "center" : alignment === "right" ? "flex-end" : "flex-start"}
        flexWrap="wrap"
        className="all-answers"
        ref={forwardedRef}
        {...props}
      >
        {options?.map(({ id, label, description, image, emoji }, index) => (
          <Option
            key={"option_" + index}
            value={id}
            name={name}
            disabled={loading || (areChoicesDisabled && !value.includes(id))}
            checked={value.includes(id)}
            onChange={(checked: boolean) => {
              /** @todo handle checkboxes */

              //Multiple choice
              if (isMultipleChoice) {
                if (value.includes(id)) {
                  onChange(value.filter((item) => item !== id));
                } else {
                  onChange([...value, id]);
                }
                //Single Choice
              } else if (checked) {
                onChange([id]);
              }
            }}
            type={type}
            hasDescription={!!description}
            pageSettings={pageSettings}
            {...optionProps}
            render={(p) =>
              fieldType === FlowNodeType.Image || fieldType === FlowNodeType.ImageMulti ? (
                <OptionImage title={label} src={image} pageSettings={pageSettings} {...p} />
              ) : (
                <OptionChoice
                  title={label}
                  subtext={description}
                  right={
                    (fieldType === FlowNodeType.Emoji || fieldType === FlowNodeType.EmojiMulti) &&
                    emoji && (
                      <Text fontSize="38px">
                        <span role="presentation">{emoji}</span>
                      </Text>
                    )
                  }
                  {...p}
                  type={isMultipleChoice ? "checkbox" : "radio"}
                />
              )
            }
            isImage={fieldType === FlowNodeType.Image || fieldType === FlowNodeType.ImageMulti}
          />
        ))}
      </Flex>
    );
  }
);
